module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "sub-container"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "top-container"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('div', {
    staticClass: "viewzzz-container"
  }, [_c('div', {
    staticClass: "view"
  }, [_vm._v("view"), _c('span', {
    staticClass: "viewzzz-main-z"
  }, [_vm._v("Z")]), _vm._v("zz")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_c('div', {
    staticClass: "middle-container"
  }, [_c('div', {
    staticClass: "messages"
  }, [_c('div', {
    staticClass: "message-container"
  }, [_c('div', {
    staticClass: "imp-message"
  }, [_c('div', {
    staticClass: "text-head"
  }, [_vm._v("\n                  Sorry this site is undergoing some Changes\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "text-sub-head"
  }, [_vm._v("\n                  Please check with us again soon!\n                ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "bottom-container"
  })]), _vm._v(" "), _c('div', {
    staticClass: "social-main-container"
  }, [_c('div', {
    staticClass: "bottom-sub-container"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3e32322","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/maintainer.vue
// module id = 531
// module chunks = 17